import React, { Component } from "react";
import Grid from '../layout/grid'

class radioSimNao extends Component {
    constructor(props) {
        super(props);
        this.state = { status: props.input.value === "" ? true : props.input.value }
    }

    alterStatus(_status) {
        this.setState({ ...this.state, status: _status })
        this.props.input.value = _status
    }

    render() {
        return (
            <Grid cols={this.props.cols}>
                <div className="form-group">
                    <label >{this.props.label}</label>
                    <div className="radio" >

                        <label for="sim" >
                            <input {...this.props.input} type="radio" value={this.props.valueSim}
                                checked={this.state.status === true}
                                onClick={() => this.alterStatus(this.props.valueSim)}
                                disabled={this.props.readOnly} />
                            {this.props.descSim}</label>
                        &ensp;
                        <label >
                            <input {...this.props.input} type="radio" value={this.props.valueNao}
                                checked={this.state.status === false}
                                onClick={() => this.alterStatus(this.props.valueNao)}
                                disabled={this.props.readOnly} />
                            {this.props.descNao}</label>

                    </div>
                </div>

            </Grid>
        );
    }
}

export default radioSimNao;


// WEBPACK FOOTER //
// ./src/common/form/radioSimNao.jsx